export default __webpack_public_path__ + "static/media/6.e12dabb9.png";